import {Component, OnInit, OnDestroy, ViewEncapsulation } from '@angular/core';
import { CriticalEditionService } from '../../../services/critical-edition.service';
import { CeStructureTree } from '../../../models/ce-structure-tree';
import { ISubscription } from 'rxjs/Subscription';

@Component({
  selector: 'app-page-critical-edition-tei-downloads',
  templateUrl: './page-critical-edition-tei-downloads.component.html',
  styleUrls: ['./page-critical-edition-tei-downloads.component.css'],
  encapsulation: ViewEncapsulation.None
})
export class PageCriticalEditionTeiDownloadsComponent implements OnInit, OnDestroy {
    pageName = 'critical_edition_tei_downloads';
    private subscriptions: Array<ISubscription> = [];
    ceStructureTree: CeStructureTree;

    constructor(
        private criticalEditionService: CriticalEditionService
    ) {
    }

    ngOnInit(): void {
        this.subscriptions.push(
            this.criticalEditionService.getStructureTree().subscribe(
                response => this.ceStructureTree = response,
                err => console.error(err)
            )
        );
    }

    public downloadTeiXml(struct: string) {
        this.criticalEditionService.downloadStructure(false, struct)
            .subscribe(
                fileUrl => {
                    this.downloadFileAsAttachment(fileUrl, struct + '.xml');
                },
                err => {
                    console.error(err);
                    alert('Error while downloading the file!\n' + err.message);
                }
            );
    }

    public downloadTransTeiXml(lang: string, struct: string) {
        this.criticalEditionService.downloadTranslationStructure(false, lang, struct)
            .subscribe(
                fileUrl => {
                    this.downloadFileAsAttachment(fileUrl, struct + '.' + lang + '.xml');
                },
                err => {
                    console.error(err);
                    alert('Error while downloading the file!\n' + err.message);
                }
            );
    }

    private downloadFileAsAttachment(url: string, name: string) {
        const a = document.createElement('a');
        document.body.appendChild(a);
        a.setAttribute('style', 'display: none');
        a.href = url;
        a.download = name;
        a.click();
        URL.revokeObjectURL(url);
        a.remove();
    }

    ngOnDestroy() {
        for (const subscription of this.subscriptions) {
            if (subscription) {
                subscription.unsubscribe();
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/app/components/pages/page-critical-edition-tei-downloads/page-critical-edition-tei-downloads.component.ts